import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Quote = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      viewBox="0 0 32 32"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2.667 4.8) rotate(180, 13.333, 11.2)">
        <path
          d="M9.6 24H1.067A1.066 1.066 0 0 1 0 22.933V12.267C0 6.886 2.016 3.325 5.992 1.681a1.067 1.067 0 0 1 .816 1.972C3.919 4.847 2.393 7.321 2.164 11.2H9.6a1.067 1.067 0 0 1 1.067 1.067v10.666A1.066 1.066 0 0 1 9.6 24z"
          transform="translate(0 -1.6)"
        />
        <path
          d="M20.8 24h-8.533a1.066 1.066 0 0 1-1.067-1.067V12.267c0-5.38 2.016-8.942 5.992-10.586a1.067 1.067 0 0 1 .816 1.972c-2.889 1.194-4.415 3.668-4.644 7.547H20.8a1.067 1.067 0 0 1 1.067 1.067v10.666A1.066 1.066 0 0 1 20.8 24z"
          transform="translate(3.733 -1.6)"
        />
      </g>
    </svg>
  );
};

Quote.displayName = 'Quote';
